export type NameRendererPosition = {
  from: number;
  to: number;
  format: boolean;
};
const nameRendererCreatePositions = (
  text: string,
  positions: Array<NameRendererPosition>
): Array<NameRendererPosition> => {
  const positionsFilled = [];

  positions.forEach((pos, index) => {
    if (index === 0 && pos.from !== 0) {
      // add start range before formatted range
      positionsFilled.push({ from: 0, to: pos.from, format: false });
    }

    if (index > 0) {
      // add range between two formatted ranges
      positionsFilled.push({
        from: positions[index - 1].to,
        to: pos.from,
        format: false,
      });
    }

    // add range to format
    positionsFilled.push(pos);

    if (index === positions.length - 1 && pos.to < text.length) {
      // add end range after last formatted range
      positionsFilled.push({ from: pos.to, to: text.length, format: false });
    }
  });

  return positionsFilled;
};

export default nameRendererCreatePositions;
